module.exports = __webpack_public_path__ + "img/icon-folder-white.25ecd150.svg";